import { Grid, Typography } from "@material-ui/core";
import SanitizedGrid from "components/SanitizedGrid";
import CreateAdhocCreditNoteByCsvButton from "./components/CreateAdhocCreditNoteByCsvButton";
import UnapprovedCreditNoteTable from "./components/UnapprovedCreditNoteTable";
import HeaderContent from "../../components/layout/components/HeaderContent";
import ExportCommercialDocumentButton from "../commercialDocuments/components/ExportCommercialDocumentButton";
import { availableOnlySuperAdmin } from "utils/validation";

const UnapprovedCreditNoteList = () => {
  const breadcrumb = [
    { link: "/unapprovedCreditNotes", title: "Unapproved Credit Notes" },
  ];

  return (
    <>
      <HeaderContent
        breadcrumb={breadcrumb}
        headerTitle="Unapproved Credit Notes"
        isNotHaveSchoolFilter
      />
      <SanitizedGrid container spacing={2}>
        <Grid item xs={6}>
          <Typography variant="h6">Unapproved Credit Notes</Typography>
        </Grid>
        <Grid item xs={6}>
          <CreateAdhocCreditNoteByCsvButton />
          {availableOnlySuperAdmin() && (
            <ExportCommercialDocumentButton documentType="CreditNote" />
          )}
        </Grid>

        <Grid item xs={12}>
          <UnapprovedCreditNoteTable />
        </Grid>
      </SanitizedGrid>
    </>
  );
};

export default UnapprovedCreditNoteList;
